import React, { Component,Fragment } from "react";
import PropTypes from 'prop-types';
import Reflux from "reflux";
import "./login.css";
import Tools from "utils/tools";
import {setFavicon} from "utils/tool";
import {isEmpty} from "lodash";
import Image from 'components/Image';
import DxLogo from "static/icon/three.png";
import logoImg from "static/icon/logo.png";
import { Form, Icon, Input, Button, Checkbox, Modal,Tooltip } from "antd";
import { requestLogin,getWebUserName,getLoginConfigForNoLogin } from "api/api";
import Forget from "./forget";
import UserStores from "stores/user-store";
import UserActions from "actions/user-actions";
import bg0 from "./img/bg0.jpg";
import bg1 from "./img/bg1.jpg";
import bg2 from "./img/bg2.jpg";
import bg3 from "./img/bg3.jpg";
const bg = {
  bg0,
  bg1,
  bg2,
  bg3
};
const FormItem = Form.Item;

class Login extends Reflux.Component {
  static contextTypes = {
    router: PropTypes.shape.isRequired
  };

  constructor(props) {
    super(props);
    this.store = UserStores;
    this.defaultBgImg = [0, 1, 2, 3];
    this.state = {
      visible: false,
      isLoading: false,
      msg: "",
      bgIndex: 0,
      bgImg:this.defaultBgImg
    };
    this.timer = null;
  }

  componentDidMount(){
    const urlSuffix = location.search &&　location.search.substring(1);
    // console.log(urlSuffix)
    if(!isEmpty(urlSuffix)){
      getLoginConfigForNoLogin({urlSuffix}).then(res=>{
        console.log("rrrrrrrrrr",res);
        const data = res &&res.data;
        if(data){
          const {titleLogoUrl,firstTitleName,secondTitleName,backgroundSign,customBackgroundUrl,loginConfigId}=data;
          let bgImg = this.defaultBgImg;//自定义的背景图
          if(backgroundSign&&customBackgroundUrl){
            if(customBackgroundUrl.indexOf(",")>-1){
              bgImg = customBackgroundUrl.split(",");
            }else{
              bgImg=[];
              bgImg.push(customBackgroundUrl);
            }
          }
          //  = backgroundSign&&customBackgroundUrl&&customBackgroundUrl.indexOf(",")>-1&&
          // customBackgroundUrl.split(",")||this.state.bgImg;//自定义的背景图
          setFavicon(titleLogoUrl);//设置favicon 图片需要加签名
          
          document.title = firstTitleName;//标签栏名称
          this.setState({
            titleLogoUrl,
            firstTitleName,
            secondTitleName,
            backgroundSign,
            // customBackgroundUrl,
            loginConfigId,
            bgImg
          });
        }
      })
      //mock
      /* const data={
        "titleLogoUrl": "http://tencentest.hetyj.com/31038/11877062ea602d413dd5ca7a4d321d17.jpg",
        "firstTitleName": "主标题",
        "secondTitleName": "副标题",
        "backgroundSign": 1,
        "customBackgroundUrl": "http://tencentest.hetyj.com/31038/11877062ea602d413dd5ca7a4d321d17.jpg,http://tencentest.hetyj.com/31038/feab6522c8c3cd1881b47a919f3123b5.jpg",
        "loginConfigId": "tszel"
      }; */
     /*  const {titleLogoUrl,firstTitleName,secondTitleName,backgroundSign,customBackgroundUrl,loginConfigId}=data;
      const bgImg = backgroundSign&&customBackgroundUrl&&customBackgroundUrl.split(",")||this.state.bgImg;//自定义的背景图
      setFavicon(titleLogoUrl);//设置favicon 图片需要加签名
      
      document.title = firstTitleName;//标签栏名称
      this.setState({
        titleLogoUrl,
        firstTitleName,
        secondTitleName,
        backgroundSign,
        // customBackgroundUrl,
        loginConfigId,
        bgImg
      }); */

      /* mock end */
    }
  }

  bgLoopStart = () => {
    let i = 1;
    
    this.timer = setInterval(() => {
      i = i % (this.state.bgImg.length);
      this.setState(
        {
          bgIndex: i
        },
        () => {
          i++;
        }
      );
    }, 5000);
  };
  componentWillUnmount() {
    clearInterval(this.timer);
    super.componentWillUnmount();
  }
  // 第三方登录链接
  threeLogin(flag) {
    // 'https://dp.clife.net'||
    const originHost = window.location.origin;
    const pathname = window.location.pathname;
    const fallbackUrl = encodeURIComponent(
      `${originHost}${pathname}?dx#/main/plant/index`
    );
    const redirect_uri = encodeURIComponent(
      `${originHost}/v4/web/agriculture/common/admin/authorize?fallbackUrl=${fallbackUrl}`
    );
    // const loginUrl = `https://iam.ctwing.cn/auth/#/auth?client_id=WWCE1A1hAve&scope=user&state=ifj23kZ0p&redirect_uri=https%3A%2F%2Fdp.clife.net%2Fv4%2Fweb%2Fagriculture%2Fcommon%2Fadmin%2Fauthorize%3FfallbackUrl%3Dhttps%253A%252F%252Fdp.clife.net%252FplatformAdmin%252Ffarm%252F%2523%252Ffarm`
    const loginUrl = `https://iam.ctwing.cn/auth/#/auth?client_id=WWCE1A1hAve&scope=user&state=ifj23kZ0p&redirect_uri=${redirect_uri}`;
    const url = `https://iam.ctwing.cn/auth/#/auth?client_id=WWCE1A1hAve&scope=tenant&tenantId=10013184&state=ifj23kZ0p&redirect_uri=https%3A%2F%2Fhetclife.ctwing.cn%2Fv1%2Fweb%2Fagriculture%2Fcommon%2Fadmin%2Fauthorize%3FfallbackUrl%3Dhttps%253A%252F%252Fhetclife.ctwing.cn%252F%253Fdx%2523%252Fmain%252Findex`;
    if (flag) {
      window.location = url;
    } else {
      window.location = loginUrl;
    }
  }
  // 登录提交
  handleSubmit = e => {
    e.preventDefault();
    if (this.state.isLoading) return;
    if(Tools.getCookie("userInfo")){
      Modal.error({
        content:"当前已有账号登录,请先退出",
        onOk:()=>{
          // this.context.router.push({ pathname: "/farm" });
          window.location.reload(true);
        }
      });
      return false;
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          isLoading: true
        });
        // 先获取用户名
        getWebUserName({username: values.username}).then(res=>{
          console.log('res');
          // 登录接口
          let params = {
            username: res.data||values.username,
            password: Tools.encryption(values.password),
            fromCode: "agriculture"
          };
          requestLogin(params)
            .then(model => {
              let userName = model.data.userName;
              localStorage.setItem("clifeManageUsername", userName);
              if (values.remember) {
                localStorage.setItem(
                  "clifeManagePass",
                  Tools.encryption_base64(values.password)
                );
                localStorage.setItem(
                  "isPassRememberclifeManage",
                  values.remember
                );
              } else {
                localStorage.removeItem("clifeManagePass");
                localStorage.removeItem("isPassRememberclifeManage");
              }
  
              UserActions.getUserInfo(() => {
                this.setState({ msg: "登录成功", isLoading: false });
                const locationSearch = window.location.search
              .split("?")
              .pop()
              .toLocaleLowerCase();
                sessionStorage.setItem("locationSearch",locationSearch);
                const bigConfig = sessionStorage.getItem("bigConfig")?JSON.parse(sessionStorage.getItem("bigConfig")):{};
                const { firstInBig } = bigConfig;
                /* if (firstInBig!==1){
                  this.context.router.replace({ pathname: "/main/plant/index" });
                }else{
                  this.context.router.replace({ pathname: "/linyin" });
                } */
                this.context.router.replace({ pathname: "/screen/home" });
                // this.context.router.replace({ pathname: "/pineapple" });
              },()=>{
                this.setState({ msg: "登录失败", isLoading: false },()=>{
                  setTimeout(()=>{
                    this.setState({
                      msg:''
                    })
                  },3000)
                });
              },this.state.loginConfigId);
            })
            .catch(err => {
              if (!err.isCancel) {
                let code = err.code;
                let msg = err.msg||"账号或密码错误";
                // console.log(err.toString())
                if (
                  !code ||
                  err.toString() == "Error: timeout of 10000ms exceeded"
                ) {
                  this.setState({ msg: "网络错误", isLoading: false }, () => {
                    setTimeout(() => {
                      this.setState({ msg: "" });
                    }, 3000);
                  });
                  return;
                }
    
                this.setState(
                  { msg: msg, isLoading: false },
                  () => {
                    setTimeout(() => {
                      this.setState({ msg: "" });
                    }, 3000);
                  }
                );
              }
            });
        })
      }
    });
  };
  // 重置密码弹框
  handleVisible = visible => {
    this.setState({
      visible
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { bgIndex,urlSuffix,titleLogoUrl,firstTitleName,
      secondTitleName,backgroundSign,bgImg,loginConfigId } = this.state;
    const clifeManageUsername = localStorage.getItem("clifeManageUsername")
      ? localStorage.getItem("clifeManageUsername")
      : "";
    const clifeManagePass = localStorage.getItem("clifeManagePass")
      ? Tools.decryption(localStorage.getItem("clifeManagePass"))
      : "";
    const isPassRememberclifeManage = localStorage.getItem(
      "isPassRememberclifeManage"
    )
      ? true
      : false;

      // console.log("urlSuffix",urlSuffix,urlSuffix===undefined)
    return (
      <div>
        <img
          src={bg.bg0}
          style={{ opacity: 0, transform: "scale(0)" }}
          onLoad={this.bgLoopStart}
        />
        <Image src={titleLogoUrl} justUrl />
        {/* {[0, 1, 2, 3].map(item => (
          <div
            key={item}
            className={`login-bgimg bg0 ${bgIndex == item ? "active" : ""}`}
            style={{ backgroundImage: `url(${bg["bg" + item]})` }}
          />
        ))} */}
        {(bgImg||this.defaultBgImg).map((item,index) =>{
          // console.log(bgImg||this.defaultBgImg,bgImg,item,index)
          if(loginConfigId&&backgroundSign){
            return <Image div src={item} className={`login-bgimg ${bgIndex == index ? "active" : ""}`} />
          }else{
            return  (
              <div
                key={index}
                className={`login-bgimg bg0 ${bgIndex == index ? "active" : ""}`}
                style={{ backgroundImage: `url(${bg["bg" + index]})` }}
              />
            )
          }
        })}
      <Forget
          visible={this.state.visible}
          handleVisible={this.handleVisible}
        />
        <div className="login-outwrap">
          <div className="login-inwrap">
            {firstTitleName?
              <div className="login-logowrap">
                <Image src={titleLogoUrl} imageStyle={{width:75,height:75}} alt="logo" />
                <div className="login-title-wrap">
                {/* <Tooltip title={firstTitleName}> */}
                  <p style={{fontSize:34}}>
                    {firstTitleName}
                  </p>
                {/* </Tooltip> */}
                {/* <Tooltip title={secondTitleName}> */}
                  <p>
                    {
                      // secondTitleName.length > 14
                      // ? `${secondTitleName.substr(0, 13)}...`
                      // : 
                      secondTitleName}
                  </p>
                {/* </Tooltip> */}
                </div>
              </div>:
              <Fragment>
                <div className="login-logo">
                  <Image src={logoImg} alt="logo" />
                </div>
                <div className="login-title">让农民成为科技工作者</div>
              </Fragment>
            }
            <Form onSubmit={this.handleSubmit} className="login-form">
              <FormItem>
                {getFieldDecorator("username", {
                  rules: [
                    { required: true, message: "账号不能为空" },
                    { max: 30, message: "最大长度30" }
                  ],
                  initialValue: clifeManageUsername
                })(
                  <Input
                    className="login-form-input"
                    prefix={
                      <Icon
                        type="user"
                        style={{ color: "rgba(59, 150, 255, 1)", fontSize: 24 }}
                      />
                    }
                    placeholder="请输入账号"
                  />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator("password", {
                  rules: [
                    { required: true, message: "密码不能为空" },
                    { max: 20, message: "最大长度20" }
                  ],
                  initialValue: clifeManagePass
                })(
                  <Input
                    className="login-form-input"
                    prefix={
                      <Icon
                        type="lock"
                        style={{ color: "rgba(59, 150, 255, 1)", fontSize: 24 }}
                      />
                    }
                    type="password"
                    placeholder="请输入密码"
                  />
                )}
              </FormItem>
              <FormItem>
                {getFieldDecorator("remember", {
                  valuePropName: "checked",
                  initialValue: isPassRememberclifeManage
                })(
                  <Checkbox className="login-form-checkbox">
                    <div className="login-form-tips">
                      记住密码(在公共场所建议不要使用此功能)
                    </div>
                  </Checkbox>
                )}
                <div
                  className="login-form-forgot"
                  onClick={() => this.handleVisible(true)}
                >
                  忘记密码
                </div>
                <Button htmlType="submit" className="login-form-button">
                  {this.state.isLoading ? "登录中..." : "登录"}
                </Button>
                <div className="login-error-tips">{this.state.msg}</div>
              </FormItem>
            </Form>
            {!loginConfigId?
            <div className="login-three">
            其他方式登录：
            <img
              style={{
                position: "relative",
                top: -4,
                cursor: "pointer",
                height: 20
              }}
              onClick={() => {
                this.threeLogin();
              }}
              src={DxLogo}
            />
          </div>:null
            }
            
          </div>
        </div>
        {!loginConfigId?
        <div className="login-copyright">
          <p>
            Copyright ©2017-2018 C-Life -
            深圳和而泰家居在线网络科技有限公司版权所有
          </p>
        </div>:null}
      </div>
    );
  }
}

export default Form.create()(Login);
